exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "\n.index-number {\n  display: inline-block;\n  height: 100%;\n  overflow: hidden;\n}\n.index-number > .number-wrap {\n    list-style: none;\n    -webkit-transition: margin-top 2s;\n    transition: margin-top 2s;\n    float: left;\n}\n.index-number > .number-wrap > .background {\n      /*background: url(\"~@/assets/layout/background-border-pro.png\") no-repeat;*/\n      background-size: 100% 100%;\n      width: 70px;\n      height: 100px;\n}\n.index-number > .number-wrap > .number {\n      text-align: center;\n      line-height: 1.4;\n      font-family: HighlandGothicFLF;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-290d881e","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/EvNumber.vue
// module id = ryN+
// module chunks = 289